import { Injector, runInInjectionContext, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';

export function waitForSignalLoaded(
  loadedSignal: Signal<boolean>,
  injector?: Injector
): Promise<boolean> {
  const fn = (): Promise<boolean> =>
    new Promise<boolean>(resolve => {
      toObservable(loadedSignal)
        .pipe(
          filter(loaded => loaded),
          take(1)
        )
        .subscribe({ next: () => resolve(true) });
    });

  return injector ? runInInjectionContext(injector, fn) : fn();
}
